// extracted by mini-css-extract-plugin
export default {"component":"header__vMX9U","mathleticslibrary":"header__k7gQW","btn-wrapper":"header__NLBxL","back-button":"header__qtlc9","btn-arrow":"header__p5GJp"};